import { Component, EventEmitter, OnChanges, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-consultation-type-modal',
  templateUrl: './consultation-type-modal.component.html',
  styleUrls: ['./consultation-type-modal.component.scss']
})
export class ConsultationTypeModalComponent implements OnInit {

  @Output() close = new EventEmitter<string>();
  @Output() confirm = new EventEmitter<string>();

  public selectedConsultationType: 'HOSPITAL' | 'VIDEO' = 'HOSPITAL';

  public consultationOptions = [
    {
      value: 'HOSPITAL',
      label: 'consult_type_hospital',
      icon: 'assets/icons/clinic.svg'
    },
    {
      value: 'VIDEO',
      label: 'consult_type_video',
      icon: 'assets/icons/packages/homevideo.svg'
    }
  ];

  constructor() {}
  
  ngOnInit(): void {

  }

  closeModal(action: string) {
    this.close.emit(action);
  }

  onRadioChange(option: any) {
    this.selectedConsultationType = option.value;
  }

  onConfirm() {
    if (!this.selectedConsultationType) {
      return;
    }
    this.confirm.emit(this.selectedConsultationType);
  }
}
